import React from 'react'
import { Link } from 'react-router-dom'
import Navbar from '../components/navbar'
import Footer from '../components/footer'
import ScrollToTop from '../components/scroll-to-top'
import hero from '../assets/images/hero/alianzas.jpg'
import Alianzas from '../components/alianzas'
import { Helmet } from 'react-helmet-async'

export default function Alianzaspage() {
    const basedomain = process.env.REACT_APP_BASE_URL;
    return (
        <>
            <Helmet>
                <title>Alianzas | Hospital Aranda de La Parra</title>
                <meta name="description" content="Estamos comprometidos con la excelencia en el cuidado de la salud y el bienestar de nuestros pacientes. " />
                <meta property="og:title" content="Alianzas | Hospital Aranda de La Parra" />
                <meta property="og:description" content="Estamos comprometidos con la excelencia en el cuidado de la salud y el bienestar de nuestros pacientes. " />
                <meta property="og:image" content={`${basedomain}${hero}`} />
                <meta property="og:url" content={`${basedomain}/alianzas`} />
                <meta property="og:type" content="website" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Alianzas | Hospital Aranda de La Parra" />
                <meta name="twitter:description" content="Estamos comprometidos con la excelencia en el cuidado de la salud y el bienestar de nuestros pacientes. " />
                <meta name="twitter:image" content={`${basedomain}${hero}`} />
                <meta itemprop="name" content="Alianzas | Hospital Aranda de La Parra" />
                <meta itemprop="description" content="Estamos comprometidos con la excelencia en el cuidado de la salud y el bienestar de nuestros pacientes. " />
                <meta itemprop="image" content={`${basedomain}${hero}`} />
            </Helmet>
            <Navbar />

            <section className="bg-half-170 d-table w-100" style={{ backgroundImage: `url(${hero})`, backgroundPosition: 'center' }}>
                <div className="bg-overlay bg-gradient-overlay"></div>
                <div className="container">
                    <div className="row mt-5 justify-content-center">
                        <div className="col-12">
                            <div className="title-heading text-center">
                                <h5 className="heading fw-semibold mb-0 sub-heading text-white title-dark">Alianzas</h5>
                            </div>
                        </div>
                    </div>

                    <div className="position-middle-bottom">
                        <nav aria-label="breadcrumb" className="d-block">
                            <ul className="breadcrumb breadcrumb-muted mb-0 p-0">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Alianzas</li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </section>

            <div className="position-relative">
                <div className="shape overflow-hidden text-white">
                    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                    </svg>
                </div>
            </div>
            <section className="section">
                <div className="container mt-50 mt-60">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="section-title text-center mb-4 pb-2">
                                <h4 className="title mb-3">Alianzas</h4>
                                <p className="text-muted para-desc mx-auto mb-0">
                                    Estamos comprometidos con la excelencia en el cuidado de la salud y el bienestar de nuestros pacientes. Para lograrlo, hemos establecido alianzas estratégicas con instituciones y profesionales de la salud, con el fin de brindar una atención integral y de calidad. A continuación, presentamos algunas de nuestras alianzas más destacadas.
                                </p>
                            </div>
                        </div>
                    </div>
                    <Alianzas />
                </div>
            </section>
            <Footer />

            <ScrollToTop />
        </>
    )
}
